/**
 * Imports the necessary modules from the React library for a React component.
 * @module React
 * @module useState
 * @module useTranslation
 */
import React from "react";
import { useTranslation } from "react-i18next";

/**
 * Imports the necessary components and utilities for the current module.
 * @import CustomButton from "../../components/customButton/customButton" - The custom button component.
 * @import ConfirmModal from "../../components/confirmModal/confirmModel" - The confirm modal component.
 * @import TextField from "../../components/TextField/TextField" - The text field component.
 * @import HookForm from "../../components/HookForm/HookForm" - The hook form component.
 * @import Constant from "../../util/constant" - The constant utility module.
 */
import CustomButton from "../../components/customButton/customButton";
import ConfirmModal from "../../components/confirmModal/confirmModel";
import TextField from "../../components/textField/textField";
import HookForm from "../../components/hookForm/hookForm";
import Constant from "../../util/constant";

/**
 * A component that renders a modal for creating a depot.
 * @param {object} props - The component props.
 * @param {function} props.showCreateDepotModal - Function to show the create depot modal.
 * @param {function} props.closeCreateDepotModal - Function to close the create depot modal.
 * @param {function} props.createDepotFun - Function to create a depot.
 * @returns The CreateDepot component.
 */
const CreateDepot = (props) => {
  /**
   * Retrieves the translation function from the useTranslation hook and initializes
   * a state variable for storing create values.
   * @returns None
   */
  const { t } = useTranslation();

  const {
    showCreateDepotModal,
    closeCreateDepotModal,
    createDepotFun,
    handleFormSubmit,
    createDepotModelLoaderButton,
    handledepottextChange,
    depottextcount,
    clearCreatData,
    createDepotFunction
  } = props;

  /**
   * An object representing a depot with its name and validation rules.
   * @property {string} name - The name of the depot.
   * @property {object} validate - The validation rules for the depot name.
   * @property {object} validate.required - The required validation rule for the depot name.
   * @property {boolean} validate.required.value - Indicates if the depot name is required.
   * @property {object} validate.pattern - The pattern validation rule for the depot name.
   * @property {string} validate.pattern.value - The regular expression pattern for the depot name.
   * @property {string} validate.pattern.message - The error message for the pattern validation rule.
   * @property {object} validate.maxLength - The maxLength validation rule for
   */
  const CreateDepot = {
    Depotname: {
      name: "Depotname",
      validate: {
        required: {
          value: false,
        },
        pattern: {
          value: Constant.REGEX.NAME,
          message: t("ALLOWED_ONLY_PERIOD_APOSTROPHE_HYPHEN_DASH_AND_SPACES"),
        },
        maxLength: {
          value: 200,
          message: t("ALLOWED_MAX_200_CHARACTERS"),
        },
      },
    },
  };

  



  return (
    /**
     * Renders a ConfirmModal component with specific props and child components.
     * @param {string} className - The class name for the ConfirmModal component.
     * @param {string} modalTitle - The title of the modal.
     * @param {boolean} showModal - Determines whether the modal is shown or hidden.
     * @param {boolean} isModelIcon - Determines whether to display an icon in the modal.
     * @param {boolean} modalContent - Determines whether to display modal content.
     * @param {boolean} isFirstButton - Determines whether to display the first button.
     * @param {boolean} isSecondButton - Determines whether to display the second button.
     * @param {function} onProcced - The function to be executed
     */
    <ConfirmModal
      className={"Deactivate import-model"}
      modalTitle={"Create Depot"}
      showModal={showCreateDepotModal}
      isModelIcon={false}
      modalContent={false}
      isFirstButton={false}
      isSecondButton={false}
      onProcced={() => {}}
      closeModelIcon={() => closeCreateDepotModal()}
      isCloseBtn={true}
    >
      {/**
       * Renders a form component with input fields for creating a depot.
       * @param {Object} defaultForm - The default form values.
       * @param {string} className - The CSS class name for the form.
       * @param {Function} init - The initialization function for the form.
       * @returns The rendered form component.
       */}
      <HookForm
        defaultForm={{
          Depotname: "",
        }}
        className="form-horizontal"
        init={(form) => {
          createDepotFunction(form);
        }}
        onSubmit={(e) => {
          handleFormSubmit(e)
        }}
      >
        {(formMethod) => {
          return (
            <>
              <div className="uploadWrapper CreateDepotWrapper">
                <div className="d-flex">
                  <p className="form-label">{t("Depot Name")}</p>
                  <p className="requiredStyle">*</p>
                </div>
                <div className="TextFiledWrapper wrapper-input">
                  <TextField
                    formMethod={formMethod}
                    rules={CreateDepot.Depotname.validate}
                    name={CreateDepot.Depotname.name}
                    errors={formMethod?.formState.errors}
                    autoFocus={true}
                    textCountVisible={true}
                    textcount={depottextcount}
                    textCountTotal={200}
                    required={false}
                    type="text"
                    placeholder={t("ENTER_DEPOT_NAME")}
                    onChange={handledepottextChange}
                  />

                  {formMethod.getValues("Depotname") !== "" ? (
                    <button
                      onClick={() => {
                        clearCreatData();
                      }}
                      className="ClearInput btn-close"
                      aria-label="Close"
                    />
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <div className="Form_buton">
                <CustomButton
                  className="black-btn Fill_Button"
                  disabled={
                    !formMethod?.formState?.isValid ||
                    !formMethod.getValues("Depotname")
                  }
                  onClick={createDepotFun}
                  loading={createDepotModelLoaderButton}
                  type="submit"
                >
                  {t("CREATE")}
                </CustomButton>
                <CustomButton
                  type="button"
                  className="black-btn Border_Button"
                  onClick={() => closeCreateDepotModal(true)}
                >
                  {t("CANCEL")}
                </CustomButton>
              </div>
            </>
          );
        }}
      </HookForm>
    </ConfirmModal>
  );
};

export default CreateDepot;
